//import Core from "ampersand-app";

//import Events from "../events";
import $ from "jquery";

var me = {
    init: function init() {
        console.log("graphs", "init()");

        me.$graphs = $("[data-hook=js-graphs]");
        me.$svg = $("[data-hook=js-svg]");

        if (me.$graphs.length > 0) {
            var currentMousePos = { x: -1, y: -1 };
            $(document).mousemove(function (event) {
                currentMousePos.x = event.pageX;
                currentMousePos.y = event.pageY;
            });

            // Check hash and add active class

            var match = location.hash.match(/^#?(.*)$/)[1];

            me.$svg.removeClass("m-active");

            if (match) {
                $(".b-svg.m-" + match).addClass("m-active");
            } else {
                $(".b-svg.m-default").addClass("m-active");
            }

            $("#Border g").hide();

            $(document).on("click", ".b-tooltip__close", function () {
                $(".b-tooltip").hide();

                return false;
            });

            $("#Hover g, #Helper g").on("click", function () {
                var offset = $(this).offset();
                var groupId = $(this).attr("id");
                var groupIdString = groupId.split("-")[1];
				if (!page.id[groupIdString]) return false;
				
                $(".b-tooltip").html("");

                if ($(window).width() > 768) {
                    $(".b-tooltip").css({
                        left: offset.left - 120 + "px",
                        top: offset.top - 60 + "px"
                    });
                } else {
                    $(".b-tooltip").css({
                        top: currentMousePos.y,
                        left: "10px"
                    });
                }

                $(".b-tooltip").html('<a href="#" class="b-tooltip__close">&times;</a>' + page.id[groupIdString]).show();
            });

            // $('#Hover g, #Helper g').on({

            // 	mouseenter: function(){

            // 		var offset = $(this).offset();
            // 		var groupId = $(this).attr('id');
            // 		var groupIdString = groupId.split('-')[1];

            // 		console.log(groupIdString);

            // 		$('.b-tooltip').html('');

            // 		if($(window).width() > 768) {

            // 			$('.b-tooltip').css({
            // 				'left' : offset.left-120+'px',
            // 				'top' : offset.top-60+'px'
            // 			});

            // 		} else {

            // 			$('.b-tooltip').css({
            // 				'top':currentMousePos.y,
            // 				'left' : '10px'
            // 			});

            // 		}

            // 		$('.b-tooltip').html(page.id[groupIdString]).show();
            // 	},
            // 	mouseleave: function(){

            // 		$('.b-tooltip').hide();
            // 	}
            // });

            // Click - change svg + add hash

            $("#Click > g").on("click", function () {
                var groupId = $(this).attr("id");
                var nr = groupId.split("-")[1];

                /*if (nr === "1" || nr === "2" || nr === "3") {
                    return false;
                } else {*/
                    window.location.hash = nr;

                    window.parent.scroll(0, 0);

                    me.$svg.removeClass("m-active");
                    $(".b-svg.m-" + nr).addClass("m-active");
                //}
            });

            // Menu - change svg + add hash

            $("#Menu > g").on("click", function (e) {
                var groupId = $(this).attr("id");
                var nr = groupId.split("-")[1];

                /*if (nr === "1" || nr === "2" || nr === "3") {
                    return false;
                } else {*/
                    window.location.hash = nr;
                    window.parent.scroll(0, 0);

                    me.$svg.removeClass("m-active");
                    $(".b-svg.m-" + nr).addClass("m-active");
                //}
            });

            $("#Menu > g, #Click > g").on({
                mouseenter: function mouseenter() {
                    var groupId = $(this).attr("id");
                    var groupIdString = groupId.split("-")[1];

                    /*if (groupIdString === "1" || groupIdString === "2" || groupIdString === "3") {
                        var offset = $(this).offset();

                        $(".b-tooltip").addClass("m-hover");

                        $(".b-tooltip").html("");

                        if ($(window).width() > 768) {
                            $(".b-tooltip").css({
                                left: offset.left + "px",
                                top: offset.top + 60 + "px"
                            });
                        } else {
                            $(".b-tooltip").css({
                                top: currentMousePos.y,
                                left: "10px"
                            });
                        }

                        $(".b-tooltip").html("<p>Valmimisel</p>").show();
                    }*/
                },
                mouseleave: function mouseleave() {
                    var groupId = $(this).attr("id");
                    var groupIdString = groupId.split("-")[1];

                    $(".b-tooltip").hide();
                    $(".b-tooltip").removeClass("m-hover");
                }
            });

            // Pop hover - highlight arrows

            $("#Pop > g, #Hover > g").on({
                mouseenter: function mouseenter() {
                    var groupId = $(this).attr("id");
                    var groupIdString = groupId.split("-")[1];

                    $("#Arrow g#Arrow-" + groupIdString).find("polygon").css({
                        fill: "red"
                    });
                    $("#Arrow g#Arrow-" + groupIdString).find("line").css({
                        stroke: "red"
                    });
                    $("#Arrow g#Arrow-" + groupIdString).find("polyline").css({
                        stroke: "red"
                    });
                    $("#Arrow g#Arrow-" + groupIdString).find("path").css({
                        stroke: "red"
                    });
                    $("#Arrow g#Arrow-" + groupIdString).find("rect").css({
                        stroke: "red"
                    });
                    $("#Border g#Border-" + groupIdString).show();
                },
                mouseleave: function mouseleave() {
                    var groupId = $(this).attr("id");
                    var groupIdString = groupId.split("-")[1];

                    $("#Arrow g#Arrow-" + groupIdString).find("polygon").css({
                        fill: "#262626"
                    });
                    $("#Arrow g#Arrow-" + groupIdString).find("line").css({
                        stroke: "#262626"
                    });
                    $("#Arrow g#Arrow-" + groupIdString).find("polyline").css({
                        stroke: "#262626"
                    });
                    $("#Arrow g#Arrow-" + groupIdString).find("path").css({
                        stroke: "#262626"
                    });
                    $("#Arrow g#Arrow-" + groupIdString).find("rect").css({
                        stroke: "#262626"
                    });
                    $("#Border g#Border-" + groupIdString).hide();
                }
            });

            // Pop click - show popup

            $("#Pop > g").on("click", function () {
                var groupId = $(this).attr("id");
                var groupIdString = groupId.split("-")[1];
                if (!page.id[groupIdString]) return false;
				$(".b-popup").addClass("m-active");
                // $('.b-popup__content').css({
                // 	'top' : currentMousePos.y
                // });
                $(".b-popup__content-inner").html(page.id[groupIdString]);
            });

            // // Helper click - show popup

            // $('#Helper > g').on('click', function(){

            // 	var groupId = $(this).attr('id');
            // 	var groupIdString = groupId.split('-')[1];
            // 	$('.b-popup').addClass('m-active');
            // 	$('.b-popup__content-inner').html(page.id[groupIdString]);
            // });

            // Close popup

            $(".b-popup__close").on("click", function () {
                $(".b-popup").removeClass("m-active");
                return false;
            });

            $(document).keyup(function (e) {
                if (e.keyCode === 27 && $(".b-popup").hasClass("m-active")) {
                    $(".b-popup").removeClass("m-active");
                }
            });

            $(document).on("mouseenter", ".m-title", function () {
                if ($(window).width() >= 1025) {
                    var tip = $(this).data("title");
                    $(this).append('<span class="tip">' + tip + "</div>");
                    $(".tip").show();
                    var tipPos = $(".tip").offset();
                    var parentPos = $(".b-popup__content-inner").offset();
                    var parentWidth = $(".b-popup__content-inner").width();
                    var parentHeight = $(".b-popup__content-inner").height();
                    var tipTop = tipPos.top - parentPos.top;
                    var tipLeft = tipPos.left - parentPos.left;

                    if (tipLeft + 200 > parentWidth) {
                        $(".tip").css({
                            left: "-220px"
                        });
                    }
                }
            }).on("mouseleave", ".m-title", function () {
                if ($(window).width() >= 1025) {
                    $(".tip").stop().remove();
                }
            });

            $(document).on("click", ".m-title", function () {
                if ($(window).width() < 1025) {
                    if ($(".tip").length > 0) {
                        $(".tip").remove();
                    } else {
                        var tip = $(this).data("title");
                        $(this).append('<span class="tip">' + tip + "</div>");
                        $(".tip").show();
                        var tipPos = $(".tip").offset();
                        var parentPos = $(".b-popup__content-inner").offset();
                        var parentWidth = $(".b-popup__content-inner").width();
                        var parentHeight = $(".b-popup__content-inner").height();
                        var tipTop = tipPos.top - parentPos.top;
                        var tipLeft = tipPos.left - parentPos.left;

                        if (tipLeft + 220 > parentWidth) {
                            $(".tip").css({
                                left: "-220px"
                            });
                        }
                    }

                    return false;
                }
            });

            // Hash check

            $(window).on("hashchange", function () {
                var match = location.hash.match(/^#?(.*)$/)[1];

                $(".b-svg").removeClass("m-active");

                if (match) {
                    $(".b-svg.m-" + match).addClass("m-active");
                } else {
                    $(".b-svg.m-default").addClass("m-active");
                }
            });
        }
    }
};

export default me;